import React, { useState } from 'react';
import MainCalculatorsList from '../MainCalculators';
import SharedHelmet from '../Helmet';
import RelatedLinks from '../RelatedLinks';
import { CalculatorsType } from '../ConstantsEN';
import { FirstAds, SecondAds , MobileUnderCalAds } from "../../Ads";
const TITLE = 'Tank Area Calculator - Calculate Tank Area Based on Dimensions';
const DESCRIPTION = 'Tank Area Calculator calculates the area of a tank based on the entered dimensions and the rectangles composing the tank.';
const KEYWORDS = 'Tank Area, Calculate Tank Area, Tank Area Calculator';
const OG_URL = 'https://do-calculate.com/calculator/en/tank-area';
function Calculator() {
    const [length, setLength] = useState('');
    const [width, setWidth] = useState('');
    const [height, setHeight] = useState('');
    const [totalArea, setTotalArea] = useState('');
    const [error, setError] = useState('');
    const handleCalculate = () => {
        if (!length || !width || !height) {
            setError('Please enter the dimensions correctly');
            setTotalArea('');
            return;
        }
        const lengthValue = parseFloat(length);
        const widthValue = parseFloat(width);
        const heightValue = parseFloat(height);
        if (isNaN(lengthValue) || isNaN(widthValue) || isNaN(heightValue) || lengthValue <= 0 || widthValue <= 0 || heightValue <= 0) {
            setError('Please enter valid and positive values for the dimensions');
            setTotalArea('');
            return;
        }
        const surfaceArea = 2 * (lengthValue * widthValue + lengthValue * heightValue + widthValue * heightValue);
        setTotalArea(surfaceArea.toFixed(2));
        setError('');
    };
    return (
        <div className="ltr">
            <SharedHelmet TITLE={TITLE} DESCRIPTION={DESCRIPTION} KEYWORDS={KEYWORDS} OG_URL={OG_URL}  />
            <div className="row">
                <div className="col-12 col-md-8">
                    <FirstAds />
                </div>
            </div>
            <div className="row">
                <div className="col-12 col-md-8">
                    <br />
                    <div className="bg-success text-white text-center" style={{ height: '40px' }}>
                        <h1 style={{ fontSize: '17px' }}>{TITLE}</h1>
                    </div>
                            <div className="border border-light">
                                <div className="row">
                                    <div>
                                    <h2 style={{fontSize:'18px'}}>How to Calculate Tank Area</h2>
                                        <p>
                                            A tank is a three-dimensional object composed of 6 rectangles or squares, and the tank's area is calculated based on its dimensions.
                                        </p>
                                        <p>
                                            Tank Area = 2 * (Length * Width + Length * Height + Width * Height)
                                        </p>
                                        <p>
                                            This calculator can be used to calculate the area of a tank based on the entered dimensions.
                                        </p>
                                        <hr />
                                    </div>
                                </div>
                                 <MobileUnderCalAds/>
                                <div className="row">
                                    <div className="col-sm-12 col-md-7 calculatorStyle">
                                        <div className='p-3 mb-2 bg-success text-white'>
                                            <h2 style={{ fontSize: '16px' }}>{TITLE} </h2>
                                        </div>
                                        <hr />
                                        <div dir="ltr">
                                            <div>
                                                <div className="form-group d-flex align-items-center">
                                                    <b>
                                                        <label className="form-label ms-2">Length (m)</label>
                                                    </b>
                                                    <input
                                                        type="number"
                                                        placeholder="Length"
                                                        value={length}
                                                        onChange={(e) => setLength(e.target.value)}
                                                        className="form-control"
                                                        style={{ width: '150px' }}
                                                    />
                                                </div>
                                                <br />
                                                <div className="form-group d-flex align-items-center">
                                                    <b>
                                                        <label className="form-label ms-2">Width (m)</label>
                                                    </b>
                                                    <input
                                                        type="number"
                                                        placeholder="Width"
                                                        value={width}
                                                        onChange={(e) => setWidth(e.target.value)}
                                                        className="form-control"
                                                        style={{ width: '150px' }}
                                                    />
                                                </div>
                                                <br />
                                                <div className="form-group d-flex align-items-center">
                                                    <b>
                                                        <label className="form-label ms-2">Height (m)</label>
                                                    </b>
                                                    <input
                                                        type="number"
                                                        placeholder="Height"
                                                        value={height}
                                                        onChange={(e) => setHeight(e.target.value)}
                                                        className="form-control"
                                                        style={{ width: '150px' }}
                                                    />
                                                </div>
                                                <br />
                                                <button
                                                    className="btn btn-success"
                                                    style={{ fontSize: '20px' }}
                                                    onClick={handleCalculate}
                                                >
                                                    Calculate Tank Area
                                                </button>
                                            </div>
                                            <br />
                                            <div>
                                                {error !== '' ? (
                                                    <p className='p-3 mb-2 bg-warning text-white'>Error: {error}</p>
                                                ) : (
                                                    <>
                                                        {totalArea !== '' && (
                                                            <>
                                                                <p className='p-3 mb-2 bg-success text-white'>
                                                                    Tank Area (square meters): {totalArea}
                                                                </p>
                                                                <p className='p-3 mb-2 bg-info text-black'>
                                                                    Solution Steps: <br />
                                                                    - Calculate the area of each of the six rectangles.
                                                                    - Then sum the areas of the six rectangles to get the total area of the tank.
                                                                </p>
                                                            </>
                                                        )}
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <hr />
                                <div className="row">
                                    <RelatedLinks />
                                    <hr />
                                </div>
                            </div>
                </div>
                <div className="col" >
                    <SecondAds />
                    <br />
                    <MainCalculatorsList CalculatorsTypeId={CalculatorsType.mathCalculators}></MainCalculatorsList>
                    <br />
                </div>
            </div>
             <br />
        </div>
    );
}
export default Calculator;
